import React from 'react';
import SolveFlowConnector from '../Visualeffects/SolveFlowConnector';

export default function SolverTwoPanelLayout({
  inputCard,
  outputCard,
  loading,
}) {

  const inputWrapperRef = React.useRef(null);
  const previousLoadingRef = React.useRef(loading);
  const [inputHeight, setInputHeight] = React.useState(0);
  const [hasShownResults, setHasShownResults] = React.useState(false);

  React.useEffect(() => {
    if (previousLoadingRef.current && !loading) {
      setHasShownResults(true);
    }
    previousLoadingRef.current = loading;
  }, [loading]);

  React.useEffect(() => {
    const node = inputWrapperRef.current;
    if (!node || typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (entry) {
        setInputHeight(entry.contentRect.height);
      }
    });

    observer.observe(node);
    setInputHeight(node.offsetHeight);

    return () => observer.disconnect();
  }, [inputCard]);

  const shouldLockOutputHeight = !hasShownResults || loading;
  const outputMinHeightStyle =
    shouldLockOutputHeight && inputHeight
      ? { minHeight: `${Math.round(inputHeight)}px` }
      : undefined;

  return (
    <div className="flex w-full flex-col items-center gap-0 pt-2 lg:flex-row lg:items-stretch lg:justify-center lg:pt-4">
      <div
        ref={inputWrapperRef}
        className="relative isolate mx-auto w-full max-w-[450px] lg:max-w-[480px]"
      >
        <div className="relative z-10">{inputCard}</div>
      </div>
      <SolveFlowConnector loading={loading} anchorHeight={inputHeight} />
      <div className="mx-auto w-full max-w-[450px] lg:max-w-[520px]">
        <div className="flex h-full flex-col" style={outputMinHeightStyle}>
          {outputCard}
        </div>
      </div>
    </div>
  );
}
